import { combineReducers } from 'redux';
import _ from 'lodash';
import {
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTION,
  FETCH_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION,
  UPDATE_TRANSACTION,
  UPDATE_TRANSACTION_SUCCESS,
  UPDATE_TRANSACTION_FAILED,
} from './types';

export const details = function(state = { pending: true, data: {} }, action) {
  switch (action.type) {    
    case FETCH_TRANSACTION:
      return { ...state, pending: true };
    case FETCH_TRANSACTION_SUCCESS:
      return { ...state, pending: false, data: action.payload };
    case UPDATE_TRANSACTION:
      return { ...state, ...action.payload };
    case UPDATE_TRANSACTION_SUCCESS:
      return { ...state, ...action.payload  };
    case UPDATE_TRANSACTION_FAILED:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}


export const list = function(state = { pending: true }, action) {
  switch (action.type) {
    case FETCH_TRANSACTIONS:
      return  { ...state, pending: true } ;
    case FETCH_TRANSACTIONS_SUCCESS:
      return  { ...state, pending: false, data: action.payload } ;
    case DELETE_TRANSACTION:
      return _.omit(state, action.payload);
    default:
      return state;
  }

}

export default combineReducers({
  details,
  list
});



// WEBPACK FOOTER //
// ./src/data/transactions/reducer.js